import React from 'react';
import SectionCourier from './SectionCourier';
import './MailboxScene.css';

/*
 * MailboxScene
 * The courier's final stop: a warm evening scene of a mailbox on a garden
 * post, with the courier arriving to deliver the last envelope. The scene
 * art is one inline SVG; the bird is the shared SectionCourier so it enters
 * once and settles. Entirely decorative (aria-hidden) — the real contact
 * links live in HTML beside it. No dark gradients, no photograph.
 */
function MailboxScene() {
  return (
    <div className="mailbox-scene" aria-hidden="true">
      <svg
        className="mailbox-svg"
        viewBox="0 0 440 360"
        role="presentation"
        focusable="false"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="mb-sky" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#f6efe1" />
            <stop offset="0.55" stopColor="#f4e6d3" />
            <stop offset="1" stopColor="#efdcc6" />
          </linearGradient>
          <linearGradient id="mb-ground" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#a8be9a" />
            <stop offset="1" stopColor="#7d9a73" />
          </linearGradient>
          <radialGradient id="mb-sun" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor="#f0c877" />
            <stop offset="1" stopColor="#f0c877" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* sky */}
        <rect x="0" y="0" width="440" height="360" fill="url(#mb-sky)" />
        {/* low evening sun glow */}
        <circle cx="128" cy="150" r="96" fill="url(#mb-sun)" opacity="0.8" />
        <circle cx="128" cy="150" r="34" fill="#eec97e" opacity="0.55" />

        {/* distant soft hills */}
        <path d="M0 250c80-26 150-18 230 2s150 6 210-10v118H0Z" fill="#c3d3b4" opacity="0.6" />

        {/* ground */}
        <path d="M0 286c120-20 200-8 300-4s90-4 140-14v92H0Z" fill="url(#mb-ground)" />

        {/* little tuft of grass */}
        <g stroke="#6d8a63" strokeWidth="3" strokeLinecap="round">
          <path d="M96 320c-2-10-4-16-2-24" />
          <path d="M104 320c1-9 3-15 8-22" />
          <path d="M110 320c3-7 8-11 14-13" />
        </g>

        {/* mailbox post */}
        <rect x="300" y="240" width="14" height="86" rx="3" fill="#8a6b3c" stroke="#38443e" strokeWidth="2.4" />

        {/* mailbox body */}
        <g stroke="#38443e" strokeWidth="2.6" strokeLinejoin="round">
          <path d="M258 214h74a0 0 0 0 1 0 0v40a0 0 0 0 1 0 0h-74a20 20 0 0 1 0-40Z" fill="#a9c7d8" />
          <path d="M258 214a20 20 0 0 0 0 40" fill="none" stroke="#38443e" />
          {/* door seam + knob */}
          <path d="M318 218v32" stroke="#7fa3bb" strokeWidth="2" />
          <circle cx="326" cy="234" r="2.4" fill="#38443e" />
        </g>

        {/* raised flag */}
        <g stroke="#38443e" strokeWidth="2.4" strokeLinecap="round">
          <path d="M332 214v-26" />
          <path d="M332 190h16v12h-16Z" fill="#e5b8ae" />
        </g>

        {/* a delivered envelope resting against the post */}
        <g transform="rotate(-8 286 300)">
          <rect x="266" y="288" width="40" height="26" rx="3" fill="#fffdf8" stroke="#38443e" strokeWidth="2" />
          <path d="M267 290l19 12 19-12" fill="none" stroke="#b9863c" strokeWidth="2" strokeLinecap="round" />
        </g>

        {/* one paperclip detail on the envelope */}
        <path
          d="M300 286v10a3 3 0 0 1-6 0v-11a1.6 1.6 0 0 1 3.2 0v10"
          fill="none"
          stroke="#b9863c"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>

      {/* the courier, arriving to deliver the final letter */}
      <SectionCourier
        className="mailbox-bird"
        carry="letter"
        width={82}
        from={{ x: 22, y: -14, rotate: 12 }}
        restRotate={-4}
        delay={0.1}
      />

      {/* one subtle drifting firefly */}
      <span className="mailbox-firefly" />
    </div>
  );
}

export default MailboxScene;
